module.exports = __webpack_public_path__ + "img/icon-dola-songlong.1f0a6eda.png";